import React, { useState } from "react";
import { Link } from "react-router-dom";
import { theDiscoverDinningDropdown } from "./NavItems";
import "./DiningDropdown.css";
import { HashLink } from "react-router-hash-link";

function DiningDropdown() {
  const [dropdown, setDropdown] = useState(false); // create stute

  const redirectToPage = (a) => {
    window.location = a;
  };

  return (
    <>
      <div className="navigation-sub-title-sec">
        <div className="navigation-sub-nav-bar ">
          <div className="navigation-sub-nav-part col">
            <div className="subNav-part-sec1">
              <ul className="sub-title-list">
                <div className="subnav-header-sec">
                  <li>
                    <p
                      className="subNavHeader"
                      onClick={() => redirectToPage("/DiningAndDrinks")}
                    >
                      - Dining & Drinks
                    </p>
                  </li>
                </div>
                {theDiscoverDinningDropdown.map((item) => {
                  if (item.id < 7) {
                    return (
                      <div className="subnav-list-item">
                        <li key={item.id}>
                          <HashLink
                            to={item.path}
                            className="submenu-item1 "
                            // onClick={() => redirectToPage(item.path)}
                          >
                            {item.title}
                          </HashLink>
                        </li>
                      </div>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
          <div className="navigation-sub-nav-part col">
            <div className="subNav-part-sec1">
              <ul className="sub-title-list">
                <div className="subnav-header-sec">
                  <li>
                    <p
                      className="subNavHeader"
                      onClick={() => redirectToPage("/Restaurants")}
                    >
                      - Restaurants
                    </p>
                  </li>
                </div>
                {theDiscoverDinningDropdown.map((item) => {
                  if (item.id > 6 && item.id < 9) {
                    return (
                      <div className="subnav-list-item">
                        <li key={item.id}>
                          <HashLink
                            to={item.path}
                            className="submenu-item1"
                            // onClick={() => redirectToPage(item.path)}
                          >
                            {item.title}
                          </HashLink>
                        </li>
                      </div>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
          <div className="navigation-sub-nav-part col">
            <div className="subNav-part-sec1">
              <ul className="sub-title-list">
                <div className="subnav-header-sec">
                  <li>
                    <p
                      className="subNavHeader"
                      onClick={() => redirectToPage("/Bars")}
                    >
                      - Bars
                    </p>
                  </li>
                </div>
                {theDiscoverDinningDropdown.map((item) => {
                  if (item.id > 8 && item.id < 12) {
                    return (
                      <div className="subnav-list-item">
                        <li key={item.id}>
                          <HashLink
                            to={item.path}
                            className="submenu-item1"
                            // onClick={() => redirectToPage(item.path)}
                          >
                            {item.title}
                          </HashLink>
                        </li>
                      </div>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
          <div className="navigation-sub-nav-part col">
            <div className="subNav-part-sec1">
              <ul className="sub-title-list">
                <div className="subnav-header-sec">
                  <li>
                    <p
                      className="subNavHeader"
                      onClick={() => redirectToPage("/ExperienceSubItems")}
                    >
                      - Experience
                    </p>
                  </li>
                </div>
                {theDiscoverDinningDropdown.map((item) => {
                  if (item.id > 11) {
                    return (
                      <div className="subnav-list-item">
                        <li key={item.id}>
                          <HashLink
                            to={item.path}
                            className="submenu-item1"
                            // onClick={() => redirectToPage(item.path)}
                          >
                            {item.title}
                          </HashLink>
                        </li>
                      </div>
                    );
                  }
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DiningDropdown;
